export default {
    cptDataForm: {
        dataText: '[{"value":"16:34 张三登录系统"},{"value":"16:56 xx扫码支付78元"},{"value":"17:16 xx扫码支付23元"},{"value":"17:36 xx扫码支付16元"}]', dataSource: 1, pollTime: 0
    },
    attribute: {
        showLine: 3, color: '#fff', fontSize:13
    },
    // interaction:{intType: 'none'}
}